import React, { Suspense, lazy, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import * as Loading from "@repoflow/components/loading";

import { Filter, DEFAULT_RANGE, buildFilter, rangeLabel } from "components/statistics/filter";

// recharts and its d3 tree are ~100KB gzipped. Lazily loaded so /site — the
// section this app is actually worked in, and the one carrying a code editor
// already — never pays for them, the same way the other three dashboards do it.
// `Filter` above is imported eagerly because it must render before the chunk
// lands, and it is what the e2e waits on.
const OrganizationCharts = lazy(() => import("../charts"));

export const Sidebar = () => null;

export const Indice = () => null;

// Everything about this ORGANIZATION that is a number, on one screen: what it
// did over the selected window. This is auth's and datum's dashboard exactly —
// the same filter row over the same charts. bucketws' keeps one panel above its
// filter, and that is not a divergence: its panel is the organization's OWN size
// limit, one row scoped to the same thing the screen is scoped to. pagews
// declares no limit against its statistics point, so there is no equivalent row
// to draw here.
//
// EVERYTHING HERE IS A WINDOW, and six of the seven measures in it are deltas:
// +1 as a site, page, section, key or file appears and -1 as it goes, and the
// file's bytes on and off the same way. So nothing on this screen is a holding —
// "how many pages does this organization have", "how much is it storing" — those
// are sums over all of history, and datum clamps a capture window to 31 days.
// The seventh, sessions, only ever adds, so its total is complete; so is the
// count of uploads beside it, which is a count of events rather than a measure.
export const Content = () => {
  const [applied, setApplied] = useState(() => ({
    filter: buildFilter({ range: DEFAULT_RANGE }),
    range: DEFAULT_RANGE,
  }));

  return (
    <Container>
      <div className="mt-4"></div>

      {/* One filter row above everything it scopes. Both aggregates below
          re-render against this slice and neither has a filter of its own.

          It produces a range and an event type, and no dimension at all: orgId
          is forced by the server and rejected if sent, and siteId is grouped by
          rather than filtered on. */}
      <Row>
        <Col>
          <Filter onApply={setApplied} />
        </Col>
      </Row>

      <Row>
        <Col>
          <Suspense fallback={<Loading.Content />}>
            <OrganizationCharts
              filter={applied.filter}
              range={applied.range}
              rangeLabel={rangeLabel(applied.range)}
            />
          </Suspense>
        </Col>
      </Row>
    </Container>
  );
};
